import { Box, MenuItem, TextField } from "@mui/material";
import React from "react";

const BankDetailsView = ({
  values,
  setFieldValue,
  handleBlur,
  touched,
  errors,
}: any) => {
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
        }}
      >
        <TextField
          fullWidth
          id="account_name"
          label="Account Name"
          size="small"
          value={values?.account_name}
          onChange={(e) => setFieldValue("account_name", e.target.value)}
          sx={{ mt: 1.5, mr: { xs: 0, md: 1 } }}
          onBlur={handleBlur}
          helperText={
            errors.account_name && touched.account_name
              ? errors.account_name
              : ""
          }
          error={errors.account_name && touched.account_name ? true : false}
          InputLabelProps={{
            required: true,
          }}
        />
        <TextField
          fullWidth
          id="bank"
          label="Bank Name"
          size="small"
          value={values?.bank}
          onChange={(e) => setFieldValue("bank", e.target.value)}
          sx={{ mt: 1.5, mr: { xs: 0, md: 1 } }}
          onBlur={handleBlur}
          helperText={errors.bank && touched.bank ? errors.bank : ""}
          error={errors.bank && touched.bank ? true : false}
          InputLabelProps={{
            required: true,
          }}
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
        }}
      >
        <TextField
          fullWidth
          id="account_no"
          label="Account No"
          size="small"
          value={values?.account_no}
          onChange={(e) => setFieldValue("account_no", e.target.value)}
          sx={{ mt: 1.5, mr: { xs: 0, md: 1 } }}
          onBlur={handleBlur}
          helperText={
            errors.account_no && touched.account_no ? errors.account_no : ""
          }
          error={errors.account_no && touched.account_no ? true : false}
          InputLabelProps={{
            required: true,
          }}
        />
        <TextField
          fullWidth
          id="confirm_account_no"
          label="Confirm Account No"
          size="small"
          value={values?.confirm_account_no}
          onChange={(e) => setFieldValue("confirm_account_no", e.target.value)}
          sx={{ mt: 1.5, mr: { xs: 0, md: 1 } }}
          onBlur={handleBlur}
          helperText={
            errors.confirm_account_no && touched.confirm_account_no
              ? errors.confirm_account_no
              : ""
          }
          error={
            errors.confirm_account_no && touched.confirm_account_no
              ? true
              : false
          }
          InputLabelProps={{
            required: true,
          }}
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
        }}
      >
        <TextField
          fullWidth
          id="branch"
          label="Branch Name"
          size="small"
          value={values?.branch}
          onChange={(e) => setFieldValue("branch", e.target.value)}
          sx={{ mt: 1.5, mr: { xs: 0, md: 1 } }}
          onBlur={handleBlur}
          helperText={errors.branch && touched.branch ? errors.branch : ""}
          error={errors.branch && touched.branch ? true : false}
          InputLabelProps={{
            required: true,
          }}
        />
        <TextField
          fullWidth
          id="ifsc_code"
          label="IFSC Code"
          size="small"
          value={values?.ifsc_code}
          onChange={(e) => setFieldValue("ifsc_code", e.target.value)}
          sx={{ mt: 1.5, mr: { xs: 0, md: 1 } }}
          onBlur={handleBlur}
          helperText={
            errors.ifsc_code && touched.ifsc_code ? errors.ifsc_code : ""
          }
          error={errors.ifsc_code && touched.ifsc_code ? true : false}
          InputLabelProps={{
            required: true,
          }}
        />
      </Box>

      <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" } }}>
        {/* Account Type */}
        <TextField
          select
          fullWidth
          id="account_type"
          label="Account Type"
          size="small"
          value={values?.account_type || ""}
          onChange={(e) => setFieldValue("account_type", e.target.value)}
          sx={{ mt: 1.5, mr: { xs: 0, md: 1 } }}
          onBlur={handleBlur}
          helperText={
            errors.account_type && touched.account_type
              ? errors.account_type
              : ""
          }
          error={Boolean(errors.account_type && touched.account_type)}
          InputLabelProps={{ required: true }}
        >
          <MenuItem value="savings">Savings</MenuItem>
          <MenuItem value="current">Current</MenuItem>
        </TextField>

        {/* Is Primary */}
        <TextField
          select
          fullWidth
          id="is_primary"
          label="Primary Account"
          size="small"
          value={values?.is_primary ?? ""}
          onChange={(e) => setFieldValue("is_primary", e.target.value)}
          sx={{ mt: 1.5 }}
          onBlur={handleBlur}
          helperText={
            errors.is_primary && touched.is_primary ? errors.is_primary : ""
          }
          error={Boolean(errors.is_primary && touched.is_primary)}
          InputLabelProps={{ required: true }}
        >
          <MenuItem value="true">Yes</MenuItem>
          <MenuItem value="false">No</MenuItem>
        </TextField>
      </Box>
    </Box>
  );
};

export default BankDetailsView;
